<template>
<svg data-svg-lvl-3="cover-back-contour" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Задник_Контур"><path class="bc-c-1" d="M392.2358,15.9935H124.66c-1.1935,0-2.3381.4741-3.182,1.3181l-8.0289,8.0292c-.2275.2276-.3274.5081-.3243.7824.0064.5609,0,387.5435,0,387.5435-.0007.608.492,1.1012,1.1,1.1012h278.0133c5.0424,0,9.13-4.0876,9.13-9.13V25.1257c0-5.0227-4.1095-9.1322-9.1322-9.1322Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.bc-c-1{fill:gray;stroke:#232728;stroke-miterlimit:2;stroke-width:1.1415px;}.bc-c-2{opacity:.3;}.bc-c-3{fill:#64ff00;stroke-width:0px;}</style>

